import { AGGREGATE_NAMES, CHAT_RESOLVERS, USER_ROLES } from 'cpool-constants';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { useCaptureChatEntryLoadError } from '~/features/whatsapp/hooks/useCaptureChatEntryLoadError';
import { useHasOwnDivisionPhoneNumber } from '~/features/whatsapp/hooks/useHasOwnDivisionPhoneNumber';
import { type ChatEntryState, resolveChatEntryState } from '~/features/whatsapp/utils/resolveChatEntryState';
import useUserInfo from '~/hooks/useUserInfo';

export const useResolvedChatEntryState = (
    hasExistingChats: boolean | null | undefined,
    existingChatsError: Error | null,
): ChatEntryState => {
    const user = useUserInfo();
    const { permissions } = useAclPermissions();
    const hasPhoneNumber = useHasOwnDivisionPhoneNumber();
    useCaptureChatEntryLoadError(hasExistingChats === null ? existingChatsError : null, AGGREGATE_NAMES.CHAT);

    return resolveChatEntryState({
        hasChatAccess: permissions.resolvers[AGGREGATE_NAMES.CHAT][CHAT_RESOLVERS.getChats],
        hasExistingChats,
        hasPhoneNumber,
        isAdmin: user?.role === USER_ROLES.admin,
    });
};
